import React from 'react';
import PropTypes from 'prop-types';
import {Space} from 'antd';
import {useTranslation} from 'react-i18next';
import {StyledTotalCardsBalance} from './StyledTotalCardsBalance';
import {
  StyledBarAmountListItemName,
  StyledBarAmountListItemValue,
  StyledBarAmountListItemWrapper,
  StyledBarAmountProgress
} from '../../../List/BarAmountList/StyledBarAmountList';
import {amountHelpers} from '../../../../utils/helpers';
import {colorsStyles} from '../../../../utils/styles';


const TotalCardsBalance = ({actual, expected, ...rest}) => {
  const [t] = useTranslation('main');

  const fillPercent = (actual / expected * 100).toFixed(2) || 0;

  return (
    <StyledTotalCardsBalance
      {...rest}
      size={9}
      direction='vertical'
    >
      <h5>{t(('totalCardBalance'))}</h5>
      <Space
        direction='vertical'
        size={4}
        style={{ width: '100%' }}
      >
        <StyledBarAmountListItemWrapper>
          <StyledBarAmountListItemName>{amountHelpers.getAmountWithCurrencyCode(actual)}</StyledBarAmountListItemName>
          <StyledBarAmountListItemValue>{amountHelpers.getAmountWithCurrencyCode(expected)}</StyledBarAmountListItemValue>
        </StyledBarAmountListItemWrapper>
        <StyledBarAmountProgress
          strokeColor={actual > expected ? colorsStyles.functional_danger : colorsStyles.neutral_8}
          percent={fillPercent}
          showInfo={false}
        />
      </Space>
    </StyledTotalCardsBalance>
  );
}

TotalCardsBalance.propTypes = {
  actual: PropTypes.number,
  expected: PropTypes.number,
}

export default TotalCardsBalance;
